/*
  MH · Produit — galerie (vignettes, défilement, points) et bouton d'achat collant (mobile).
  L'ajout au panier reste géré par le formulaire de l'ancien thème (Cart.js).
*/
(function () {
  function init(section) {
    const gallery = section.querySelector('[data-mh-gallery]');
    const track = section.querySelector('[data-mh-gallery-track]');
    const thumbs = [...section.querySelectorAll('[data-mh-thumb]')];
    const dots = [...section.querySelectorAll('.mh-product__dot')];

    // Colonne de vignettes : fondu en bas tant qu'il reste des vignettes, en haut dès qu'elle a défilé
    const thumbsWrap = section.querySelector('[data-mh-thumbs-wrap]');
    const thumbsList = section.querySelector('[data-mh-thumbs]');
    function updateThumbsFade() {
      if (!thumbsWrap || !thumbsList) return;
      const remaining = thumbsList.scrollHeight - thumbsList.clientHeight - thumbsList.scrollTop;
      thumbsWrap.classList.toggle('has-more', remaining > 1);
      thumbsWrap.classList.toggle('has-prev', thumbsList.scrollTop > 1);
    }
    if (thumbsList) {
      thumbsList.addEventListener('scroll', updateThumbsFade, { passive: true });
      window.addEventListener('resize', updateThumbsFade, { passive: true });
      thumbsList.querySelectorAll('img').forEach((img) => img.addEventListener('load', updateThumbsFade, { once: true }));
      updateThumbsFade();
    }

    function setActive(index) {
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      // La vignette active reste visible dans la colonne
      const current = thumbs[index];
      if (current && thumbsList && thumbsList.scrollHeight > thumbsList.clientHeight) {
        const top = current.offsetTop - thumbsList.offsetTop;
        if (top < thumbsList.scrollTop || top + current.offsetHeight > thumbsList.scrollTop + thumbsList.clientHeight) {
          thumbsList.scrollTo({ top: top - (thumbsList.clientHeight - current.offsetHeight) / 2, behavior: 'smooth' });
        }
      }
    }

    function goTo(index, smooth = true) {
      if (!track) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(index);
    }

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.mhThumb))));

    // Boutons précédent / suivant sur le visuel (desktop) : on boucle du dernier au premier et inversement
    const count = track ? track.children.length : 0;
    const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    section.querySelector('[data-mh-gallery-prev]')?.addEventListener('click', () => goTo((current() - 1 + count) % count));
    section.querySelector('[data-mh-gallery-next]')?.addEventListener('click', () => goTo((current() + 1) % count));

    if (track) {
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
          ticking = false;
        });
      }, { passive: true });

      const start = Number(gallery?.dataset.startIndex || 0);
      if (start > 0) goTo(start, false);
    }

    // Choix de quantité en cartes : règle la quantité du formulaire d'achat et le prix affiché
    // (bouton d'achat s'il montre le prix, barre d'achat collante)
    const qtyGroup = section.querySelector('[data-mh-qty]');
    if (qtyGroup) {
      const applyQty = () => {
        const checked = qtyGroup.querySelector('.mh-qty__input:checked');
        if (!checked) return;
        section.querySelectorAll('[data-mh-buy] input[name="quantity"]').forEach((input) => {
          input.value = checked.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (checked.dataset.price) {
          section.querySelectorAll('[data-mh-buy] [data-product-price], .mh-product__sticky-price').forEach((el) => {
            el.textContent = checked.dataset.price;
          });
        }
      };
      qtyGroup.addEventListener('change', applyQty);
      applyQty();
    }

    // Prix masqué en attendant WideBundle (voir le bloc « Prix ») : il reste masqué si les cartes de l'app
    // arrivent, sinon il s'affiche dès que l'app a répondu (5 s au plus) ; le résultat est mémorisé
    const autoPrice = section.querySelector('.mh-product__price--auto');
    const buyBlock = section.querySelector('[data-mh-buy]');
    if (autoPrice && buyBlock) {
      const key = 'mh-wb-' + autoPrice.dataset.productId;
      let settled = false;
      const settle = (hasBundle) => {
        if (settled) return;
        settled = true;
        autoPrice.hidden = hasBundle;
        try { localStorage.setItem(key, hasBundle ? '1' : '0'); } catch (e) {}
      };
      const check = () => { if (buyBlock.querySelector('#new-form')) settle(true); };
      check();
      if (!settled) {
        const formObserver = new MutationObserver(() => { check(); if (settled) formObserver.disconnect(); });
        formObserver.observe(buyBlock, { childList: true, subtree: true });
        const giveUp = () => setTimeout(() => { if (!buyBlock.querySelector('#new-form')) settle(false); }, 600);
        // Réponse de WideBundle (offres du produit) : ses cartes suivent de peu, sinon il n'y en a pas
        if ('PerformanceObserver' in window) {
          const already = performance.getEntriesByType('resource').some((e) => e.name.includes('widebundle.com/scripttagAjax'));
          if (already) giveUp();
          else {
            const net = new PerformanceObserver((list) => {
              if (list.getEntries().some((e) => e.name.includes('widebundle.com/scripttagAjax'))) { net.disconnect(); giveUp(); }
            });
            net.observe({ type: 'resource', buffered: true });
          }
        }
        setTimeout(() => { check(); settle(false); }, 5000);
      }
    }

    // Accordéons limités à 4 lignes : « Voir plus » seulement si le texte dépasse (mesuré à l'ouverture)
    section.querySelectorAll('[data-mh-clamp-toggle]').forEach((button) => {
      const content = section.querySelector('#' + button.getAttribute('aria-controls'));
      const details = button.closest('details');
      if (!content) return;
      const measure = () => {
        if (content.classList.contains('is-expanded') || (details && !details.open)) return;
        button.hidden = content.scrollHeight <= content.clientHeight + 1;
      };
      button.addEventListener('click', () => {
        const expanded = content.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      });
      details?.addEventListener('toggle', measure);
      window.addEventListener('resize', measure, { passive: true });
      measure();
    });

    // Lien « Retour » : page précédente si elle vient du site, sinon la collection
    section.querySelector('[data-mh-back]')?.addEventListener('click', (event) => {
      if (document.referrer && new URL(document.referrer).origin === window.location.origin && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    });

    // Barre d'achat collante (desktop sous la navigation, mobile en bas de l'écran) : visible quand
    // le bloc Achat est passé au-dessus de l'écran, sous la barre de navigation fixe ; le clic suit le
    // bouton de WideBundle quand l'app l'injecte (le bouton d'origine est alors masqué)
    const sticky = section.querySelector('[data-mh-sticky]');
    const buy = section.querySelector('[data-mh-buy]');
    const realButton = buy?.querySelector('button[type="submit"], .product__add-to-cart');
    if (sticky && buy && realButton) {
      sticky.querySelector('[data-mh-sticky-button]')?.addEventListener('click', () => {
        (buy.querySelector('#new-form-atc') || realButton).click();
      });

      if ('IntersectionObserver' in window) {
        let observer;
        const watch = () => {
          observer?.disconnect();
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mh-sticky-header-height')) || 0;
          observer = new IntersectionObserver(([entry]) => {
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < headerHeight);
          }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px' });
          observer.observe(buy);
        };
        watch();
        window.addEventListener('resize', watch, { passive: true });
      }
    }
  }

  document.querySelectorAll('[data-mh-product]').forEach(init);

  // Éditeur de thème : chaque réglage recharge la section, mais WideBundle n'injecte ses cartes (#new-form)
  // qu'au chargement de la page. Son widget est mis de côté avant le rechargement puis remis à sa place,
  // après le formulaire d'achat, pour que l'aperçu reste juste ; la fiche est ensuite réinitialisée.
  if (window.Shopify && window.Shopify.designMode) {
    let keptWidget = null;
    document.addEventListener('shopify:section:unload', (event) => {
      const widget = event.target.querySelector('[data-mh-buy] #new-form');
      if (widget) keptWidget = widget;
    });
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-mh-product]').forEach((section) => {
        const buy = section.querySelector('[data-mh-buy]');
        if (keptWidget && buy && !buy.querySelector('#new-form')) {
          const form = buy.querySelector('form');
          if (form) form.after(keptWidget);
          else buy.append(keptWidget);
        }
        init(section);
      });
    });
  }
})();
